import {NodeViewProps,findParentNode} from "@tiptap/core";
import React, {useEffect, useRef, useState} from "react";
import {NodeViewContent, NodeViewWrapper} from "@tiptap/react";
import {
    calcTextAreaHeight, calcTextHeight,
    createCopyLink, createPdfAnnoTextElement,
    decodeDeeplink,
    firstLetterUpper,
    formatDate, formatDateHms,
    generateUUID2, getImagePath, getImagePathWithSvg,
    getImagePathWithTheme, getImagePathWithThemeSvg, getItem,
    imgPathPerfix, isDarkMode, isInDraw, isNumber, isString, isStringNullOrEmpty
} from "@/utils";
import {
    EVENT_OPEN_LIBRARY_ITEM, EVENT_REFRESH_DEEPLINK,
    EVENT_REFRESH_DEEPLINK_TITLE, EVENT_REFRESH_LIBRARY_LIST,
    EVENT_REFRESH_RECENTS,
    EVENT_SHOW_DIALOG_DRAWINDEX,
    FROM_LIBRARY, KEY_IS_FIRST_OPEN_LIBRARY_REF, KEY_JOURNAL_SELECT_VIEW, MAX_Z_INDEX, usedColorToShowColor
} from "@/Const";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {createDeeplinkView, deepLinkToLinkInfo, getCardTitle, isMac} from "@/Utility";
import {Dropdown, message, Tooltip} from "antd";
import i18next, {t} from "i18next";
import {getNoteById} from "@model/note";
import {getCardById, updateCard} from "@model/card";
import {dbGetHighlight} from "@model/highlight";
import {IconCopyLink} from "@/Icon";
import {mutateElement} from "../../../@excalidraw/packages/excalidraw";
import {ipcInvoke} from "@/common/ipc";
import {findNodeWithParents, loopAllNode} from "@/TreeUtils";
import {APP_WEB} from "@/electron_interactive";


const DeeplinkView = ({editor,node,updateAttributes,extension}:NodeViewProps)=>{

    const [isOpen,setIsOpen] = useState(false);
    const [isExist,setIsExist] = useState(true);
    const [title,setTitle] = useState('');
    const [libraryData,setLibraryData] = useState<any>(null);
    const [parentLibraryData,setParentLibraryData] = useState<any>(null);
    const [videoNote,setVideoNote] = useState(null);
    const bCanShowTooltip = useRef(false);
    const mDeeplink = useRef<any>(null);
    const [isShowContextMenu,setIsShowContextMenu] = useState(false);

    const mIsShowContextMenu = useRef(false);
    //是否是独占的link
    const [isExclusiveDeeplink,setIsExclusiveDeeplink] = useState(false);
    const [isInStart,setIsInStart] = useState(false);//是否在开始位置，如果在开始位置，不要左边距
    const [isInVisible,setIsInVisible] = useState(true);

    const spContainerRef = useRef(null);
    const mProjectData = useRef<any>({project:null,element:null});

    const mLibraryData = useRef<any>(null);
    const mThisGUID = useRef(generateUUID2());


    useEffect(()=>{
        const deeplink = decodeDeeplink(node.attrs.href);
        mDeeplink.current = deeplink;

        recvMessage(EVENT_REFRESH_DEEPLINK_TITLE,(msg,data)=>{
            const libraryData = data.data.data;
            if (libraryData?.id == deeplink?.id){
                setTitle(libraryData.name);
            }
        })

        // const dom = document.getElementById(node.attrs.id);
        // const rect = dom.getBoundingClientRect();
        // console.log(rect);

        if (editor.isShowSliderTip){
            bCanShowTooltip.current = true;
        }
        setTitle(node.attrs.text);

        refreshDeeplink(deeplink);

        // const szContent = getCurrentBlockContent(editor);
        //不存在独占一行的情况了 2025-05-24
        // if (node.attrs.isExclusiveDeeplink != null){
        //     setIsExclusiveDeeplink(node.attrs.isExclusiveDeeplink);
        // }else{
        //     const isSingle = isStringNullOrEmpty(szContent) || szContent == '@';
        //     setIsExclusiveDeeplink(isSingle);
        //     updateAttributes({isExclusiveDeeplink:isSingle})
        // }

        const isInS = getIsInParStart();
        setIsInStart(isInS);

        return ()=>{
            // unSubscribe(EVENT_REFRESH_DEEPLINK_TITLE);
        }

    },[])

    useEffect(() => {
        /**
         * 刷新deeplink
         */
        recvMessage(EVENT_REFRESH_DEEPLINK,(msg,data)=>{
            if (data.data.id == mDeeplink.current?.id){
                refreshDeeplink(mDeeplink.current);
            }
        })

        return ()=>{
            unSubscribe(EVENT_REFRESH_DEEPLINK);

        }
    });

    useEffect(() => {
        if (node.attrs.type == 'embed'){
            setIsExclusiveDeeplink(true);
        }
    }, [node.attrs.type]);

    useEffect(()=>{
        mIsShowContextMenu.current = isShowContextMenu;
    },[isShowContextMenu])

    useEffect(() => {
        window.refreshList['refresh_canvas_deeplink_card_title_'+mThisGUID.current] = refreshCanvasDeeplinkCardTitle;
        return ()=> {
            delete window.refreshList['refresh_canvas_deeplink_card_title_' + mThisGUID.current];
        }
    }, [title]);

    /**
     * 别的card修改的时候刷新这个deeplink的标题..
     * @param data
     */
    function refreshCanvasDeeplinkCardTitle(data:any){
        if (mLibraryData.current && data.id == mLibraryData.current?.id){
            mLibraryData.current.name = data.name;
            setTitle(getCardTitle(mLibraryData.current));
        }

        if (mProjectData.current.project && mProjectData.current.element?.customData?.generationData?.id == data.id){
            let szContent = mProjectData.current.project.name;
            mProjectData.current.element.customData.generationData.name = data.name;
            szContent += '->' + data.name || t("Untitled");
            setTitle(szContent);
        }

        if (mProjectData.current.project && mProjectData.current.project.id == data.id){
            let szContent = data.name || t('Untitled');
            szContent += '->' + mProjectData.current.element?.customData?.generationData?.name || t("Untitled");
            setTitle(szContent);
        }
    }

    //是否在第一个位置.
    function getIsInParStart(){
        let pos = findNodePosById(node.attrs.id);
        if (!pos)return;
        const parentNode = findParagraphParentFromPos(pos);
        if (!parentNode)return;
        // const coords = editor.view.coordsAtPos(parentNode.pos);
        if (parentNode){
            const children = parentNode.node?.content?.content;
            if (children){
                if (children.length == 0){
                    return true;
                }
                return children[0].attrs?.id == node.attrs.id;
            }
        }

        return false;
    }

    const findParagraphParentFromPos = (childPos) => {
        try{
            const $pos = editor.state.doc.resolve(childPos);
            // 从当前深度向上查找
            for (let d = $pos.depth; d > 0; d--) {
                const node = $pos.node(d);
                if (node.type.name === 'paragraph') {
                    return {
                        node,
                        pos: $pos.before(d),
                        depth: d
                    };
                }
            }
        }catch (e){

        }

        return null;
    };

    function findNodePosById(id) {
        let pos = null;
        editor.state.doc.descendants((node, nodePos) => {
            if (node.attrs.id === id) {
                pos = nodePos;
                return false;
            }
        });
        return pos;
    }

    function getCurrentBlockContent(editor) {
        const { state } = editor;
        const { $from } = state.selection;

        // 获取当前文本块节点
        const node = $from.node();

        return node.textContent;
    }

    const MENU:any = [
        {
            label:<span style={{color:'#838383'}}>{t("Paste as")}</span>,
            value:'pasteAs',
            disabled:true
        },
        getItem(t("Mention"), 'mention', null, undefined, undefined, (e) => {
            updateAttributes({
                type:'mention',
                isFirst:false,
            })
            setIsShowContextMenu(false);
        }),
        getItem(t("Embed"), 'embed', null, undefined, undefined, (e) => {
            //修改
            updateAttributes({
                type:'embed',
                isFirst:false,
            })
            setIsShowContextMenu(false);
        }),
    ]

    /**
     * 刷新
     */
    const refreshDeeplink = (deeplink:any)=>{
        // const deeplink = decodeDeeplink(node.attrs.href);
        let isFirst = node.attrs.isFirst;
        if (deeplink.type == 'project'){
            bCanShowTooltip.current = false;
            //region project
            getNoteById(deeplink.id).then((res)=>{
                if (res && res?.isDeleted != 1){
                    setIsExist(true);

                    let szContent = res.name;
                    const jsonDoc = JSON.parse(res.doc);
                    let szBoardName = '';
                    let mElement: any;
                    mProjectData.current.project = res;

                    let bFinished = false;
                    loopAllNode(jsonDoc.canvas,(board)=>{
                        if (!bFinished && board.key == deeplink.childId) {
                            const parents = findNodeWithParents(jsonDoc.canvas,board.key);
                            if (parents.parents){
                                for (let i=0;i<parents.parents.length;i++){
                                    szBoardName += parents.parents[i].title + ' / ';
                                }
                            }
                            szBoardName += board.title;

                            for (let j = 0; j < board.drawJson.elements.length; j++) {
                                const element = board.drawJson.elements[j];
                                if (element.id == deeplink.elementId) {
                                    mElement = element;
                                    bFinished = true;
                                }
                            }
                        }
                    })


                    if (deeplink.elementId) {
                        //取元素名称
                        if (deeplink.elementType == 'text') {
                            //取这个文本的内容
                            szContent += '->' + mElement?.text
                        }else if (deeplink.elementType == 'card'){
                            mProjectData.current.element = mElement;
                            szContent += '->' + mElement?.customData?.generationData?.name || t("Untitled");
                        }
                        else {
                            szContent += '->' + firstLetterUpper(deeplink.elementType);
                        }

                    } else if (deeplink.childId) {
                        //子board
                        szContent += '->' + szBoardName;
                    }
                    setTitle(szContent);

                }else{
                    setIsExist(false);
                }
            })
            //endregion
        }else if (deeplink.type == 'library'){
            if (deeplink.childType == 'pdfAnno' || deeplink.childType == 'cardAnno'){
                getCardById(deeplink.id)?.then(async (res)=> {
                    if (res){
                        const pdfLib: any = await getCardById(res.id);
                        setIsExist(pdfLib && pdfLib.isDeleted != 1)
                        setLibraryData(pdfLib);

                        let szContent = pdfLib.name + '->' + (res.comment || res.text);
                        if (pdfLib.annoType == 'image'){
                            szContent = pdfLib.name + '->' + (res.comment || t("Area highlight"));
                        }
                        setTitle(szContent);

                        setTimeout(()=>{
                            if (isFirst){
                                setIsShowContextMenu(true);
                            }
                        },100);
                    }
                });
            }else{
                getCardById(deeplink.id,false).then((res)=>{
                    if (res && res?.isDeleted != 1){
                        setIsExist(true);
                        if (bCanShowTooltip.current){
                            if (res.type == 'pdf' || res.type == 'video' || res.type == 'card' || res.type == 'journal'){

                            }else{
                                bCanShowTooltip.current = false;
                            }
                        }
                    }else{
                        setIsExist(false);
                    }
                    mLibraryData.current = res;
                    setTitle(getCardTitle(res))
                })
            }

        }else if (deeplink.type == 'highlight'){
            dbGetHighlight(deeplink.id).then(res=>{
                if (res){
                    setLibraryData(res);
                    const videoNote = res.data.find(p=>p.id == deeplink.childId);
                    setIsExist(videoNote != undefined && videoNote != null);
                    setVideoNote(videoNote);
                    let szTime = formatDate(videoNote.time,'hh:mm:ss');
                    if (szTime.startsWith('00:')){
                        szTime = formatDate(videoNote.time,'mm:ss');
                    }
                    getCardById(deeplink.id)?.then(library=>{
                        if (library){
                            setParentLibraryData(library);
                            const szContent = (library.name || res.name) + `(${szTime})` + '->'+(videoNote.title||videoNote.content);
                            setTitle(szContent);

                            res.name = library.name || res.name;
                            setLibraryData(res);
                        }
                    })
                }
                setTimeout(()=>{
                    if (isFirst){
                        setIsShowContextMenu(true);
                    }
                },100);
            })
        }

        setTimeout(()=>{
            updateAttributes({
                isFirst:false
            })
        },100)
    }

    const isEmptyType = ()=>{
        return !node.attrs.type || node.attrs.type == 'undefined'
    }

    /**
     * 大缩略图
     */
    const renderEmbed = ()=>{
        if (mDeeplink.current?.type == 'highlight' && mDeeplink.current?.childType == 'videoNote'){
            return(
                <div
                    style={{
                        marginTop:'4px',
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: '12px',
                        padding:'12px',
                        height: '100%',
                        width:'100%',
                        overflow: 'hidden',
                        borderRadius:'4px',
                        border:'1px solid var(--border-color)'
                    }}>
                    <div style={{display: 'flex', alignItems: 'center', flexShrink: '0px'}}>
                        <img className={'img-16'} src={getImagePath('library_video_anno')}/>
                        <span className={'span-1-line'} style={{
                            marginLeft: '6px',
                            color: '#FF9500',
                            // textOverflow: 'ellipsis',//这种属性不行。。文本内容太多的时候宽度变小，这个不会跟着变小.
                            // whiteSpace: 'nowrap',
                            // overflow: 'hidden'
                        }}>{libraryData?.name || t("Untitled")}</span>
                        <span style={{
                            marginLeft: 'auto',
                            color: 'var(--color-666666)'
                        }}>{formatDateHms(videoNote?.time)}</span>
                    </div>
                    <div>
                        <span style={{
                            color: isDarkMode() ? 'var(--text-color)' : '#000000',
                            fontSize: '16px',
                            display: 'block',
                            marginTop: '10px'
                        }}>{videoNote?.title}</span>
                        <span style={{paddingTop: '4px', display: 'block'}}>{videoNote?.content}</span>
                    </div>
                </div>
            )
        }else if (mDeeplink.current?.childType == 'pdfAnno' || mDeeplink.current?.childType == 'cardAnno'){
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: '12px',
                        padding:'12px',
                        height: '100%',
                        width:'100%',
                        marginTop:'4px',
                        overflow: 'hidden',
                        borderRadius:'4px',
                        border:'1px solid var(--border-color)'
                    }}>
                    <div style={{display: 'flex', alignItems: 'center', flexShrink: '0'}}><div
                        style={{
                            color: usedColorToShowColor(libraryData?.color),
                            border: `1.5px solid ${usedColorToShowColor(libraryData?.color)}`,
                            width: '18px',
                            height: '18px',
                            display: 'flex',
                            fontSize:'12px',
                            justifyItems: 'center',
                            justifyContent: 'center',
                            flexShrink: '0',
                            paddingBottom:'1px',
                            minHeight: '18px',
                        }}><span style={{lineHeight:'1.2'}}>A</span></div><span
                        style={{
                            marginLeft: '6px',
                            color: usedColorToShowColor(libraryData?.color),
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden'
                        }}>{"" + (libraryData?.name || '')}</span>
                    </div>
                    {/*<div*/}
                    {/*    style={{*/}
                    {/*        height: '1px',*/}
                    {/*        background: '#E4E4E4',*/}
                    {/*        marginTop: '6px',*/}
                    {/*        marginLeft: '-16px',*/}
                    {/*        marginRight: '-16px'*/}
                    {/*    }}></div>*/}
                    {
                        (libraryData?.text) &&
                        <blockquote
                            style={{
                                marginTop: '10px',
                                marginLeft: '0px',
                                marginRight: '0px',
                                paddingLeft: '8px',
                                borderLeft: `2px solid ${usedColorToShowColor(libraryData?.color)}`,
                                textAlign: 'left'
                            }}>
                                  <span style={{
                                      color: isDarkMode() ? 'var(--text-color)' : '#00000080',
                                      marginTop: '4px'
                                  }}>{libraryData?.text}</span>
                        </blockquote>
                    }
                    {
                        !libraryData?.text &&
                        <img style={{width:'100%',height:'auto',marginTop:'8px'}}
                             src={libraryData?.image || libraryData?.thumbImage}/>
                    }
                    <span style={{marginTop:'8px'}}>{libraryData?.comment}</span>
                </div>
            )
        }
        return (
            <></>
        )
    }

    const handMenuClick = (event) => {
        event.domEvent.stopPropagation();
    }

    const getTitle = (title:any)=>{
        if (isString(title)){
           const arraySplits = title?.split('\n');
           if (arraySplits.length > 0){
               return arraySplits[0];
           }
           return '';
        }
        if (isNumber(title)){
            return title+'';
        }
       return '';
    }

    const getImgSrc = (szImgName:any)=>{
        if (!isExist){
            return getImagePathWithTheme(szImgName);
        }
        return getImagePathWithSvg(szImgName + '_blue');

    }

    return (
        <NodeViewWrapper data-id={node.attrs.id} style={{ display: node.attrs.ifhidden ? 'none' : (isExclusiveDeeplink?'block':'inline-block'),maxWidth:(isExclusiveDeeplink)?'100%':'400px',width:'auto', verticalAlign: 'top',marginRight:'2px'}}>
            <NodeViewContent as={'span'}>
                <Tooltip open={isOpen} onOpenChange={(visible) => {
                    if (bCanShowTooltip.current && !node.attrs.isFirst) {
                        setIsOpen(visible);
                    } else {
                        setIsOpen(false);
                    }
                }} placement={'bottomLeft'}
                         title={i18next.t("CtrlClickToOpenInSlider").replace("Ctrl", isMac() ? 'Cmd' : 'Ctrl')}
                         arrow={false}>
                    <span className={'cursor-pointer'} ref={spContainerRef} style={{
                        display: 'flex',
                        flexDirection: 'row',
                        // alignItems: 'center',
                        marginTop: isExclusiveDeeplink?'10px':(extension?.options?.containerMarginTop || '0px'),
                        marginBottom: (isExclusiveDeeplink)?'10px':'0px',
                        opacity: isExist ? '1' : '0.25',
                        fontSize: extension?.options?.fontSize || '14px'
                    }} onClick={(event)=>{
                        event.stopPropagation();
                        //阻止click的事件传递。。。。库页面打开card--链接打开别的弹窗。。。。
                    }} onMouseUp={async (event: any) => {
                        if (isShowContextMenu)return;

                        if (event.metaKey || event.ctrlKey) {
                            event.stopPropagation();
                            // event.preventDefault();
                        }

                        if (APP_WEB) {
                            message.info(i18next.t('ContentNotAvailable'));
                            return;
                        }

                        if (!isExist) {
                            message.info(i18next.t('LinkBeDeleted'));
                            return;//已删除。
                        }
                        const deeplink = decodeDeeplink(node.attrs.href);
                        if (isInDraw()) {
                            if (deeplink.childType == 'pdf') {
                                event.stopPropagation();
                                event.preventDefault();
                            }
                        }
                        if (deeplink.type == 'library' || deeplink.type == 'highlight') {
                            postMessage(EVENT_OPEN_LIBRARY_ITEM, {
                                id: deeplink.id,
                                from: FROM_LIBRARY,
                                deeplink: deeplink,
                                selectedId: deeplink.childId,
                                inSlider: (event.metaKey || event.ctrlKey)
                            })
                            if (deeplink.childType == 'card' || deeplink.childType == 'video' || deeplink.childType == 'pdf' || deeplink.childType == 'highlight') {
                                if (window.location.href.includes('/card') || window.location.href.includes('/journal')) {
                                    const hasFirst = localStorage.getItem(KEY_IS_FIRST_OPEN_LIBRARY_REF) || 'true';
                                    if (hasFirst == 'true') {
                                        message.info(t("HoldCtrlDownAndCtrl").replace('Cmd',(isMac()?'Cmd':'Ctrl')));
                                        localStorage.setItem(KEY_IS_FIRST_OPEN_LIBRARY_REF,'false')
                                    }
                                }
                            }
                        } else {
                            const linkInfo = await deepLinkToLinkInfo(deeplink);
                            postMessage(EVENT_SHOW_DIALOG_DRAWINDEX, {linkInfo,inSlider:(event.metaKey || event.ctrlKey)});
                        }
                    }}>
                        {
                                //默认的链接
                                (isEmptyType() || node.attrs.type == 'mention') &&
                                <>
                                    <img data-type={'no-apply-hidden'} style={{
                                        opacity: '1',
                                        transform: 'none',
                                        position: 'relative',
                                        visibility: 'visible',
                                        width: '16px',
                                        height: '16px',
                                        marginLeft: (isExclusiveDeeplink || isInStart) ? '2px' : '2px',
                                        marginTop: (isExclusiveDeeplink && !extension?.options?.forceMarginTopImg) ? '5px' : (extension?.options?.marginTopImg || '5px')
                                    }}
                                         src={getImgSrc(node.attrs.image?.replace(".png", ""))}/>

                                    <Dropdown trigger={['click']} placement={"bottomRight"} onOpenChange={(e) => {
                                        if (node.attrs.isFirst) {
                                            setIsShowContextMenu(e)
                                        } else {
                                            setIsShowContextMenu(false)
                                        }
                                    }}
                                              overlayStyle={{minWidth: '180px', zIndex: `${MAX_Z_INDEX}`}}
                                              open={extension?.options?.from == 'EditorCardItem'?false:isShowContextMenu}
                                              menu={{items: MENU, onClick: handMenuClick}}>
                                        <div className={`div-span-container ${isExclusiveDeeplink ? 'ml-12' : 'ml-6'}`}
                                             style={{marginTop: '0px', marginRight: '2px'}}>
                                        <span className={isExclusiveDeeplink ? 'text-truncate' : 'text-truncate-1'}
                                              style={{
                                                  fontSize: extension?.options?.fontSize || '17px',
                                                  color: '#5281D8'
                                              }}>{getTitle(title)}</span>
                                        </div>
                                    </Dropdown>
                                </>
                        }

                        {
                            node.attrs.type == 'embed' &&
                            renderEmbed()
                        }

                        {/*<span className={'span-single-line ml-12'} style={{marginTop:'0px',height:'24px',lineHeight:'24px',maxHeight:'48px'}}>{title}</span>*/}
                    </span>
                </Tooltip>
            </NodeViewContent>

        </NodeViewWrapper>
    )
}

export default React.memo(DeeplinkView);




















